import { motion } from "framer-motion";
import { FaCheckCircle } from "react-icons/fa";

export default function IF_Pricing({ datas = [], children }) {
    if (!datas || datas.length === 0) return null;

    return (
        <div className="w-full flex justify-center px-4 md:px-8 py-8 md:py-14">
            <div className="w-full md:w-[90%] lg:w-[80%] max-w-[1300px] flex flex-col items-center gap-8">
                {/* Introduction / Description */}
                {children && (
                    <div className="w-full text-center max-w-[850px] mx-auto">
                        {children}
                    </div>
                )}

                {/* Interactive Pricing Cards Wrap (Centered Flex Wrap, Linear Motion, Zero Blur) */}
                <div className="flex flex-wrap justify-center gap-6 lg:gap-8 w-full pt-4">
                    {datas.map((data, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.8, delay: index * 0.15, ease: "linear" }}
                            whileHover={{ y: -6 }}
                            className="w-full sm:w-[calc(50%-12px)] lg:w-[calc(33.333%-22px)] max-w-[380px] flex flex-col"
                        >
                            <div className="relative flex-1 min-h-[160px] md:min-h-[180px] p-6 md:p-8 rounded-2xl bg-[#12141e] border border-pink/30 hover:border-pink transition-colors duration-200 flex flex-col justify-center items-center text-center overflow-hidden">
                                {/* Top Accent Line */}
                                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-2/5 h-[3px] bg-gradient-to-r from-transparent via-pink to-transparent rounded-full" />

                                <div className="flex items-center gap-2 mb-3">
                                    <FaCheckCircle className="text-pink text-base" />
                                    <span className="text-xs font-black text-biruMuda tracking-widest uppercase">
                                        I-Fit Program
                                    </span>
                                </div>

                                <h3 className="text-xl md:text-2xl font-extrabold tracking-wide text-white leading-tight">
                                    {data.title}
                                </h3>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export { IF_Pricing as IFPricing };
